import { useEffect, useState } from "react";
import { useUserContext } from "../../../../context/User/useUserContext";
import { SocialPostType } from "../../types/post.types";
import { CompactCreatePost } from "./CompactCreatePost";
import { ExpandedCreatePost } from "./ExpandedCreatePost";

type ComposerPreset = {
    type?: SocialPostType;
    openImageUpload?: boolean;
    openDocumentUpload?: boolean;
    initialContent?: string;
};

type CreatePostFormProps = {
    openRequest?: number;
    presetRequest?: ComposerPreset;
};

export const CreatePostForm = ({ openRequest, presetRequest }: CreatePostFormProps) => {
    const { user } = useUserContext();
    const [expanded, setExpanded] = useState(false);
    const [preset, setPreset] = useState<ComposerPreset>({});

    const handleExpand = (nextPreset: ComposerPreset = {}) => {
        setPreset(nextPreset);
        setExpanded(true);
    };

    const handleClose = () => {
        setExpanded(false);
        setPreset({});
    };

    const handleSuccess = () => {
        // Optional: Show success message or refresh feed
        // Post created successfully
    };

    useEffect(() => {
        if (!openRequest) return;
        setPreset(presetRequest ?? {});
        setExpanded(true);
    }, [openRequest, presetRequest]);

    return (
        <>
            <CompactCreatePost user={user} onExpand={handleExpand} />
            <ExpandedCreatePost
                open={expanded}
                onClose={handleClose}
                user={user}
                onSuccess={handleSuccess}
                initialType={preset.type}
                initialContent={preset.initialContent}
                openImageUpload={preset.openImageUpload}
                openDocumentUpload={preset.openDocumentUpload}
            />
        </>
    );
};

export type { ComposerPreset };
